import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import Box from '#components/a/Box'

const useModifier = (className, modifier) =>
  useMemo(() => `${className} ${className}--${modifier}`, [className, modifier])

function Tabz({tabz, tabWidth, tabMinWidth, type}) {
  const className = useModifier('tabz', type)
  let style = {}
  let tabClassName = ''
  if (tabWidth) {
    // style.width = tabWidth
    tabClassName = 'react-tabs__tab tabzStylingWidth'
  }
  if (tabMinWidth) {
    // style.minWidth = tabMinWidth
    tabClassName = 'react-tabs__tab tabzStylingMinWidth'
  }

  const title = tabz.map((tab, index) => (
    <Tab className={tabClassName} key={index.toString()} style={style}>
      <span>{tab[0]}</span>
    </Tab>
  ))
  const content = tabz.map((tab, index) => {
    const [, tabMainContent, tabSideContent] = tab
    if (tabMainContent) {
      return (
        <TabPanel key={index.toString()}>
          <Box className="react-tabs__main-content">{tabMainContent}</Box>
          {tabSideContent && <div className="react-tabs__side-content">{tabSideContent}</div>}
        </TabPanel>
      )
    }
    return <TabPanel key={index.toString()} />
  })
  return (
    <div className={className}>
      <Tabs>
        <TabList>{title}</TabList>
        {content}
      </Tabs>
    </div>
  )
}

Tabz.propTypes = {
  tabz: PropTypes.array,
  tabWidth: PropTypes.string,
  tabMinWidth: PropTypes.string,
  type: PropTypes.string,
}

export default Tabz
